import React from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  Box, Divider, Typography, Link,
} from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import OpenInNewTwoTone from '@material-ui/icons/OpenInNewTwoTone';
import Fonts from '../Themes/Fonts';
import { NO_ACCOUNT_TITLE, KUDOS_WEB_URL, KUDOS_SUPPORT_URL } from '../Constants/AppConstants';
import colors from '../Themes/Colors';

const useStyles = makeStyles({
  box: {
    paddingTop: 32,
    paddingLeft: 16,
    paddingRight: 16,
  },
  title: {
    ...Fonts.style.h5,
    textAlign: 'center',
  },
  image: {
    width: '70%',
    paddingTop: 16,
    paddingBottom: 16,
  },
  message: {
    ...Fonts.style.p,
  },
  link: {
    color: colors.blue,
  },
  icon: {
    height: 14,
    textAlign: 'center',
  },
  list: {
    paddingLeft: 16,
    paddingRight: 16,
  },
});

const NoAccountScreen = () => {
  const classes = useStyles();

  return (
    <>
      <Divider />
      <Box className={classes.box}>
        <div className={classes.title}>
          <ErrorOutlineIcon />
          <Typography component="h5" className={classes.title}>
            {NO_ACCOUNT_TITLE}
          </Typography>
          <img alt="" className={classes.image} src="assets/no-account.png" />
        </div>
        <div className={classes.message}>
          <p>
            {/* eslint-disable-next-line max-len */}
            Kudos® for Outlook is a recognition and culture platform that engages employees and aligns teams for a strong connection to your corporate culture.
          </p>
          <br />
          <p>This add-in lets you</p>
          <ul className={classes.list}>
            <li>Send and receive recognition</li>
            <li>See your company&apos;s recognition feed</li>
          </ul>
          <br />
          <p>
            Kudos requires an active subscription. For more information, visit
            <Link
              classes={{ root: classes.link }}
              href={KUDOS_WEB_URL}
              target="_blank"
              rel="noopener"
              underline="none"
            // eslint-disable-next-line react/jsx-one-expression-per-line
            > {KUDOS_SUPPORT_URL}
            </Link>
            <OpenInNewTwoTone classes={{ root: classes.icon }} />
          </p>
        </div>
      </Box>
    </>
  );
};

export default NoAccountScreen;
